import { bootstrapApplication } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { provideRouter, Router } from '@angular/router';
import { FileUploadComponent } from './app/file-upload/file-upload.component'; // Import your standalone component
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { DocumentUploadComponent } from './app/document-upload/document-upload.component';
import { registerLicense } from '@syncfusion/ej2-base';
import 'zone.js';


@NgModule({
  
  imports: [
    BrowserModule,
    // other modules
  ]
 
})
export class AppModule {}

registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWH1cc3RRRWReUUNxXkI=');
// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));

// bootstrapApplication(FileUploadComponent, {
//   providers: [provideRouter([]),provideHttpClient()] // Provide the router if needed
// });

// platformBrowserDynamic().bootstrapModule(AppComponent);


